var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    [
      _c("common-grid", {
        ref: "commonGrid",
        attrs: {
          list: _vm.RBF0405F40.chekTranGrid,
          "total-line-cnt": _vm.totalCnt,
          "scroll-event": true,
          pageType: "autoTrsacc"
        },
        on: { reSearch: _vm.RBF0405F40Call },
        scopedSlots: _vm._u([
          {
            key: "list",
            fn: function(data) {
              return [
                _c(
                  "div",
                  { staticClass: "item state" },
                  [
                    _c("div", { staticClass: "tit" }, [
                      _vm._v(" " + _vm._s(data.row.draweAcno) + " "),
                      _c("i", {
                        staticClass: "icon icon-arrow-m-right",
                        on: {
                          click: function($event) {
                            return _vm.goToDetail(data.row)
                          }
                        }
                      })
                    ]),
                    [
                      data.row.stus == "0"
                        ? _c("div", { staticClass: "desc normal" }, [
                            _vm._v(
                              _vm._s(/*이체대기*/ _vm.$t("MPAY-03-02-01-10"))
                            )
                          ])
                        : data.row.stus == "1"
                        ? _c("div", { staticClass: "desc ing" }, [
                            _vm._v(
                              _vm._s(/*이체진행*/ _vm.$t("MPAY-03-02-01-05"))
                            )
                          ])
                        : data.row.stus == "2"
                        ? _c("div", { staticClass: "desc ending" }, [
                            _vm._v(_vm._s(/*종료*/ _vm.$t("MPAY-03-02-03-03")))
                          ])
                        : _c("div", { staticClass: "desc warning" }, [
                            _vm._v(_vm._s(/*해지*/ _vm.$t("MPAY-03-02-03-04")))
                          ])
                    ]
                  ],
                  2
                ),
                _c("div", { staticClass: "item name left" }, [
                  _vm._v(_vm._s(data.row.draweAcnFname))
                ]),
                _c("div", { staticClass: "item object" }, [
                  _c("div", { staticClass: "tit" }, [
                    _vm._v(_vm._s(/* 이체금액 */ _vm.$t("MPAY-03-02-01-06")))
                  ]),
                  _c("div", { staticClass: "desc" }, [
                    _c("span", { staticClass: "exchange-unit" }, [
                      _vm._v(_vm._s(data.row.cncycd))
                    ]),
                    _c("span", {
                      staticClass: "amount",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$num(data.row.trsaccAmt, null, true)
                        )
                      }
                    })
                  ])
                ]),
                _c("div", { staticClass: "item etc" }, [
                  _c("div", { staticClass: "tit" }, [
                    _vm._v(_vm._s(_vm.$t(/* 자동이체일 */ "MPAY-03-02-08-10")))
                  ]),
                  _c("div", { staticClass: "desc" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$setTrsaccCyclDay(
                          data.row.dwkDstcd,
                          data.row.trsaccDd,
                          data.row.trsaccCyclUnitDstcd,
                          data.row.trsaccCyclUnitCnt
                        )
                      )
                    )
                  ])
                ]),
                _c("div", { staticClass: "item etc" }, [
                  _c("div", { staticClass: "tit" }, [
                    _vm._v(
                      _vm._s(/*자동 이체 기간*/ _vm.$t("MPAY-03-02-01-08"))
                    )
                  ]),
                  _c("div", { staticClass: "desc" }, [
                    _vm._v(
                      _vm._s(_vm.$getGlobalDateFmt(data.row.trsaccStartYmd)) +
                        " ~ " +
                        _vm._s(_vm.$getGlobalDateFmt(data.row.trsaccEndYmd))
                    )
                  ])
                ]),
                _vm.statusGubun == "1"
                  ? _c("div", { staticClass: "inline-button-group" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn sm inline",
                          on: {
                            click: function($event) {
                              return _vm.autoTrsaccUpdateFn(data.row)
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              /*자동 이체 변경*/ _vm.$t("MPAY-03-01-07-14")
                            )
                          )
                        ]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "btn sm inline",
                          on: {
                            click: function($event) {
                              return _vm.autoTrsaccDeleteFn(data.row)
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              /*자동 이체 해지*/ _vm.$t("MPAY-03-02-01-09")
                            )
                          )
                        ]
                      )
                    ])
                  : _vm._e()
              ]
            }
          }
        ])
      }),
      _c(
        "section",
        { staticClass: "transfer" },
        [
          _c("popup", {
            staticClass: "popup",
            attrs: {
              opened: _vm.popupOpened,
              title: /*자동이체등록 상세*/ _vm.$t("MPAY-03-02-02-01"),
              "use-header": true,
              "use-footer": true
            },
            on: {
              "update:opened": function($event) {
                _vm.popupOpened = $event
              }
            },
            scopedSlots: _vm._u([
              {
                key: "content",
                fn: function() {
                  return [
                    _c("article", { staticClass: "contents" }, [
                      _c("div", { staticClass: "account-info -type4" }, [
                        _vm.dtlData.stus == "0"
                          ? _c("span", { staticClass: "badge -type4" }, [
                              _vm._v(
                                _vm._s(/*대기*/ _vm.$t("MPAY-03-02-01-15"))
                              )
                            ])
                          : _vm.dtlData.stus == "1"
                          ? _c("span", { staticClass: "badge -type4" }, [
                              _vm._v(
                                _vm._s(/*진행*/ _vm.$t("MPAY-03-02-03-02"))
                              )
                            ])
                          : _vm.dtlData.stus == "2"
                          ? _c("span", { staticClass: "badge -type4" }, [
                              _vm._v(
                                _vm._s(/*종료*/ _vm.$t("MPAY-03-02-03-03"))
                              )
                            ])
                          : _c("span", { staticClass: "badge -type4" }, [
                              _vm._v(
                                _vm._s(/*해지*/ _vm.$t("MPAY-03-02-03-04"))
                              )
                            ]),
                        _c("div", { staticClass: "tit" }, [
                          _vm._v(_vm._s(_vm.dtlData.prdctName))
                        ]),
                        _c("div", { staticClass: "desc" }, [
                          _c("div", { staticClass: "item account" }, [
                            _vm._v(_vm._s(_vm.dtlData.draweAcno))
                          ])
                        ])
                      ]),
                      _c("dl", { staticClass: "dlist dlist-item--type4" }, [
                        _c("dt", [
                          _vm._v(
                            _vm._s(
                              /* 출금계좌번호 */ _vm.$t("MPAY-03-02-02-03")
                            )
                          )
                        ]),
                        _c("dd", [_vm._v(_vm._s(_vm.dtlData.acno))]),
                        _c("dt", [
                          _vm._v(
                            _vm._s(/* 이체금액 */ _vm.$t("MPAY-03-02-02-04"))
                          )
                        ]),
                        _c("dd", { staticClass: "right" }, [
                          _c("span", { staticClass: "exchange-unit" }, [
                            _vm._v(_vm._s(_vm.dtlData.cncycd))
                          ]),
                          _c("span", {
                            staticClass: "amount",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$num(_vm.dtlData.trsaccAmt, null, true)
                              )
                            }
                          })
                        ])
                      ]),
                      _c(
                        "dl",
                        { staticClass: "dlist dlist-item--type4" },
                        [
                          _vm.siteCode != _vm.$config.SITECODE_OGAUC
                            ? [
                                _c("dt", [
                                  _vm._v(
                                    _vm._s(
                                      /* 입금은행 */ _vm.$t("MPAY-03-02-06-05")
                                    )
                                  )
                                ]),
                                _c("dd", [
                                  _vm._v(_vm._s(_vm.dtlData.rcevnBnkName))
                                ])
                              ]
                            : _vm._e(),
                          _c("dt", [
                            _vm._v(
                              _vm._s(
                                /* 입금계좌번호 */ _vm.$t("MPAY-03-02-06-06")
                              )
                            )
                          ]),
                          _c("dd", [_vm._v(_vm._s(_vm.dtlData.draweAcno))]),
                          _c("dt", [
                            _vm._v(
                              _vm._s(/* 수취인 */ _vm.$t("MPAY-03-02-06-07"))
                            )
                          ]),
                          _c("dd", [_vm._v(_vm._s(_vm.dtlData.draweAcnFname))]),
                          _vm.siteCode == _vm.$config.SITECODE_OGMMR
                            ? [
                                _c("dt", [
                                  _vm._v(
                                    _vm._s(
                                      /*송금 목적*/ _vm.$t("MPAY-03-01-13-02")
                                    )
                                  )
                                ])
                              ]
                            : _vm._e(),
                          _vm.siteCode == _vm.$config.SITECODE_OGMMR
                            ? _c("dd", [
                                _vm._v(_vm._s(_vm.dtlData.trsaccApctRefCtnt1))
                              ])
                            : _vm._e(),
                          _c("dt", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.siteCode == _vm.$config.SITECODE_OGAUC
                                  ? "Particulars"
                                  : _vm.$t(
                                      "MPAY-03-01-11-08"
                                    ) /* 수취인 참조내용 */
                              )
                            }
                          }),
                          _c("dd", [_vm._v(_vm._s(_vm.dtlData.draweRefCtnt1))]),
                          _vm.siteCode == _vm.$config.SITECODE_OGAUC
                            ? [
                                _c("dt", [_vm._v("Code")]),
                                _c("dd", [
                                  _vm._v(_vm._s(_vm.dtlData.draweRefCtnt2))
                                ]),
                                _c("dt", [_vm._v("Reference")]),
                                _c("dd", [
                                  _vm._v(_vm._s(_vm.dtlData.draweRefCtnt3))
                                ])
                              ]
                            : _vm._e(),
                          _c("dt", [
                            _vm._v(
                              _vm._s(
                                /* 자동이체일 */ _vm.$t("MPAY-03-02-08-10")
                              )
                            )
                          ]),
                          _c("dd", [
                            _vm._v(
                              _vm._s(
                                _vm.$setTrsaccCyclDay(
                                  _vm.dtlData.dwkDstcd,
                                  _vm.dtlData.trsaccDd,
                                  _vm.dtlData.trsaccCyclUnitDstcd,
                                  _vm.dtlData.trsaccCyclUnitCnt
                                )
                              )
                            )
                          ]),
                          _vm.siteCode != _vm.$config.SITECODE_OGAUC
                            ? [
                                _c("dt", [
                                  _vm._v(
                                    _vm._s(
                                      /* 휴일인 경우 */ _vm.$t(
                                        "MPAY-03-01-07-08"
                                      )
                                    )
                                  )
                                ]),
                                _c("dd", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        _vm.dtlData.holdyTrsaccDstcd +
                                          "_휴일이체구분코드"
                                      )
                                    )
                                  )
                                ])
                              ]
                            : _vm._e(),
                          _c("dt", [
                            _vm._v(
                              _vm._s(
                                /* 이체시작일 */ _vm.$t("MPAY-03-02-08-12")
                              )
                            )
                          ]),
                          _c("dd", [
                            _vm._v(
                              _vm._s(
                                _vm.$getGlobalDateFmt(
                                  _vm.dtlData.trsaccStartYmd
                                )
                              )
                            )
                          ]),
                          _c("dt", [
                            _vm._v(
                              _vm._s(
                                /* 이체종료일 */ _vm.$t("MPAY-03-02-02-14")
                              )
                            )
                          ]),
                          _c("dd", [
                            _vm._v(
                              _vm._s(
                                _vm.$getGlobalDateFmt(_vm.dtlData.trsaccEndYmd)
                              )
                            )
                          ]),
                          _c("dt", [
                            _vm._v(
                              _vm._s(
                                /*차기 이체 영업일*/ _vm.$t("MPAY-03-02-02-18")
                              )
                            )
                          ]),
                          _c("dd", [
                            _vm._v(
                              _vm._s(
                                _vm.$getGlobalDateFmt(
                                  _vm.dtlData.nxtrmTrsaccBzoprYmd
                                )
                              )
                            )
                          ]),
                          _c("dt", [
                            _vm._v(
                              _vm._s(/* 신청일 */ _vm.$t("MPAY-03-02-02-15"))
                            )
                          ]),
                          _c("dd", [
                            _vm._v(
                              _vm._s(
                                _vm.$getGlobalDateFmt(
                                  _vm.dtlData.trsaccAplcnYmd
                                )
                              )
                            )
                          ])
                        ],
                        2
                      )
                    ])
                  ]
                },
                proxy: true
              },
              {
                key: "footer",
                fn: function() {
                  return [
                    _c(
                      "div",
                      { staticClass: "btn-area--full" },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn icon gray",
                            on: {
                              click: function($event) {
                                return _vm.popupClose()
                              }
                            }
                          },
                          [_c("i", { staticClass: "icon icon-back" })]
                        ),
                        _vm.statusGubun == "1"
                          ? [
                              _c(
                                "button",
                                {
                                  staticClass: "btn md normal",
                                  on: {
                                    click: function($event) {
                                      return _vm.autoTrsaccUpdateFn(_vm.dtlData)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      /*자동 이체 변경*/ _vm.$t(
                                        "MPAY-03-01-07-14"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "button",
                                {
                                  staticClass: "btn md normal",
                                  on: {
                                    click: function($event) {
                                      return _vm.autoTrsaccDeleteFn(_vm.dtlData)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      /*자동 이체 해지*/ _vm.$t(
                                        "MPAY-03-02-01-09"
                                      )
                                    )
                                  )
                                ]
                              )
                            ]
                          : [
                              _c(
                                "button",
                                {
                                  staticClass: "btn md normal",
                                  on: {
                                    click: function($event) {
                                      return _vm.popupClose()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(/* 확인 */ _vm.$t("MCOM-0000003"))
                                  )
                                ]
                              )
                            ]
                      ],
                      2
                    )
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }